
const popupParent = $('.news-popup-parent');
const popupBg = popupParent.find('.news-popup-close-overflow')
const popupInner = popupParent.find('.news-popup');
const popupContentOverflow = popupParent.find('.popup-news-container-overflow');
const popupContent = popupParent.find('.popup-news-container');
const popupClose = popupParent.find('.close-popup');
const popupPoints = popupParent.find('.popup-point-parent');
const articlePoint = popupPoints.eq(0);
const formPoint = popupPoints.eq(2);
const popupProgressParent = popupParent.find('.news-popup-progress-parent');
const popupProgressInner = popupProgressParent.find('.news-popup-progress-bar-inner');
const popupProgressCount = popupProgressParent.find('#count');

const articleDataParent = $('#article-data');
const newsOpenBtns = $('.news-open-btn');

let newsPopupLenis = new Lenis({
  wrapper: popupContentOverflow.get(0),
  autoRaf: true,
})

newsPopupLenis.on('scroll', (e) => {
    if (!articlePoint.length) return;

    const scroll = newsPopupLenis.scroll;
    const articleTop = articlePoint.position().top;
    const articleHeight = articlePoint.outerHeight();
    const scrollerPaddign = parseInt(popupContentOverflow.css('padding-top'))

    const start = articleTop + scrollerPaddign;
    const end = articleTop + articleHeight + scrollerPaddign;

    let progress = (scroll - start) / (end - start);
    progress = Math.max(0, Math.min(progress, 1));

    const percent = progress * 100;

    gsap.set(popupProgressInner, { width: `${percent}%` });
    popupProgressCount.text(Math.round(percent));
})

const params = new URLSearchParams(window.location.search);
const newsHandle = params.get('news');

const showNewsPopup = (immediate) => {
  const popupTL = gsap.timeline({
    paused: true,
    onStart: () => {
        lenis.stop();
        headerAnimation(false, 0.4, 0.01).play();
        newsPopupLenis.resize()
        newsPopupLenis.scrollTo(0, {immediate: true});
    },
    onComplete: () => {
        popupClose.on('click', function () {
            popupClose.off('click');
            popupTL.reverse();
        });
    },
    onReverseComplete: () => {
        lenis.start();
        gsap.set(popupParent, { pointerEvents: 'none' });
        headerAnimation(true, 0.4, 0.01).play();

        const url = new URL(window.location);
        url.searchParams.delete('news');
        window.history.replaceState({}, '', url)
    },
  });

  popupTL.add(
    gsap.set(popupParent, {
      display: 'flex',
      pointerEvents: 'all',
    }),
    0
  );

  popupTL.add(
    gsap.fromTo(
      popupBg,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.667,
        ease: 'opacityInEasing',
      }
    ),
    0
  );

  popupTL.add(
    gsap.fromTo(
      popupInner,
      { y: '100%' },
      {
        y: 0,
        duration: 0.667,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  if(!immediate){
    popupTL.play();
  } else {
    popupTL.progress(1);
  }
};

function openPopup(handle, pushState = true) {
    fetch(`/blogs/${handle}`)
        .then((res) => res.text())
        .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const article = doc.querySelector('article');
        const articleEstimatedTime = getReadingTime(article.innerText);
        articleDataParent.html(article);
        reworkTitle();
        reworkEstimatedTime(articleEstimatedTime)

        if (pushState && handle) {
          const url = new URL(window.location);
          url.searchParams.set('news', handle.replace('news/', ''));
          window.history.pushState({}, '', url);
        }

        showNewsPopup();
    });
}

const openPopupFromURL = () => {
  const handle = new URLSearchParams(window.location.search).get('news');
  if (!handle) return ;

  requestAnimationFrame(() => {
    openPopup('news/' + handle, false);
  });
};

function reworkEstimatedTime(time) {
  const articleEstimatedTime = $('#article-read-time');
  articleEstimatedTime.text(`${time} min`);
}

function reworkTitle() {
    const articleTitle = $('.article-title');
    const words = articleTitle.text().trim().split(' ');
    if (words.length > 0) {
        articleTitle.html(`<span class="first-word">${words[0]}</span> ${words.slice(1).join(' ')}`);
    }
}

$(window).on('load', function(){
    const newsCards = $('.news-card,.result-card-parent');
    newsCards.on('click', function(){
        const newsHandle = $(this).attr('data-handle');
        openPopup(newsHandle);
    })
})